<template>
  <div class="stats-display" v-if="is_load >= 2">
 
    <!-- 年份选项卡 -->
    <div class="year-tabs-container">
      <el-tabs v-model="selectedYear"
      
      @tab-click="handleYearChange" class="year-tabs"
      
      >
        <el-tab-pane
          v-for="item in yearData"
          :key="item.title"
          :label="item.title"
          :name="item.title"
        />
      </el-tabs>
    </div>
    <div class="stats-section">
      <div class="dimension-metric-selector">
        <div v-for="(group, groupKey) in metricGroups" :key="groupKey" class="metric-group" :class="groupKey">
          <h3 class="group-title">{{ group.title }}</h3>
          <div class="metric-cards">
            <div
              v-for="(label, metric) in group.metrics"
              :key="metric"
              class="metric-card"
              :class="{ 'is-active': yearSelectedMetric === metric, [groupKey]: true }"
              @click="yearSelectedMetric = metric; handleYearMetricChange()"
            >
              <div class="metric-label">{{ label }}</div>
              <div class="metric-value">
                <span class="value">{{ isMoneyMetric(metric) ? '¥' : '' }}{{ formatNumber(stats[metric]) }}</span>
              </div>
            </div>
          </div>
        </div>
         
      </div>
    </div>
    
     


    <!-- 年度趋势图 -->
    <div class="chart-container"  >
      <v-chart class="chart" :options="yearChartOption" :autoresize="true" />
    </div>

    <!-- 数据概览卡片 -->
    <div class="header-container">
    <h2 class="month-title">月度统计</h2>
    <div class="time-dimension-selector">
      <el-date-picker
        v-model="selectedDate"
        type="month"
        :format="dateFormat"
        value-format="yyyy-MM"
        @change="handleDateChange"
        placeholder="选择日期"
        class="compact-date-picker"
      />
    </div>
  </div>
  

    <!-- 图表展示区域 -->
    <div class="charts-section">
      <div class="stats-section">
        <div class="dimension-metric-selector">
          <div v-for="(group, groupKey) in metricGroups" :key="groupKey" class="metric-group">
            <h3 class="group-title">{{ group.title }}</h3>
            <div class="metric-cards">
              <div
                v-for="(label, metric) in group.metrics"
                :key="metric"
                class="metric-card"
                :class="{ 'is-active': selectedMetric === metric, [groupKey]: true }"
                @click="selectedMetric = metric; handleMetricChange()"
              >
                <div class="metric-label">{{ label }}</div>
                <div class="metric-value">
                  <span class="value">{{ isMoneyMetric(metric) ? '¥' : '' }}{{ formatNumber(metricValues[metric].value) }}</span>
                  <span class="rate" :class="{ 'up': metricValues[metric].rate > 0, 'down': metricValues[metric].rate < 0 }">
                    {{ metricValues[metric].rate > 0 ? '+' : '' }}{{ metricValues[metric].rate }}%
                    <i :class="['iconfont', metricValues[metric].rate > 0 ? 'icon-up' : 'icon-down']"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-container">
        <v-chart class="chart" :options="chartOption" :autoresize="true" />
      </div>
    </div>
  </div> 
</template>
 
<script>
import axios from 'axios';

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

use([
  CanvasRenderer,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
])
// const base_url = "http://jpbs.com/api"
const base_url = "https://api.japanbus.cn/api"
export default {
  name: 'StatsDisplay',
  components: {
    VChart
  },
  data() {
    return {
      yearData : [],
      is_load:0,
      drawerVisible: false,
      timeDimension: 'month',
      selectedDate: new Date().toISOString().slice(0, 7), // 当前日期
      selectedMetric: 'total_orders', // 月度统计选中的指标
      yearSelectedMetric: 'total_orders', // 年度统计选中的指标
      metricGroups: {
        income: {
          title: '收入',
          metrics: {
            all_in: '总入账',
            order_amount: '订单金额',
            received_amount: '回款金额',
            profit: '利润',
           
          }
        },
       
        expense: {
          title: '支出',
          metrics: {
            all_out: '总支出',
            refund_amount: '退款金额',
            ticket_cost: '购票成本',
            refund_fee: '退款手续费',
       
          }
        },
        orders: {
          title: '订单数',
          metrics: {
            total_orders: '订单总数',
            completed_orders: '完成订单数',
            refunded_orders: '退款订单数',
            lm_refunded_orders: '跨月退款订单数',
            refund_send_count: '出票退款订单数',
            refund_nosend_count: '未出票退款订单数',
            lm_refund_send_count: '跨月出票退款订单数',
            lm_refund_nosend_cont: '跨月未出票退款订单数',
            full_refund_count: '全款退款订单数',
            lm_full_refund_count: '跨月全款退款订单数'
          }
        },
        refund: {
          title: '退款数据',
          metrics: {

            full_refund: '全额退款',
            send_refund: '出票退款',
            nosend_refund: '未出票退款金额',
          
            cross_month_refund: '跨月退款金额',
            cross_send_refund: '跨月出票退款',
            cross_nosend_refund: '跨月未出票退款', 
            cross_full_send_refund: '跨月出票全额退款',
           
           
          }
        }
      },
      metricOptions: {
        total_orders: '订单总数',
        completed_orders: '完成订单数',
        refunded_orders: '退款订单数',
        lm_refunded_orders: '跨月退款订单数',
        refund_send_count: '出票退款订单数',
        refund_nosend_count: '未出票退款订单数',
        lm_refund_send_count: '跨月出票退款订单数',
        lm_refund_nosend_cont: '跨月未出票退款订单数',
        full_refund_count: '全款退款订单数',
        lm_full_refund_count: '跨月全款退款订单数',
        all_in: '总入账',
        all_out: '总支出',
        order_amount: '订单金额',
        refund_amount: '退款金额',
        cross_month_refund: '跨月退款金额',
        ticket_cost: '购票成本',
        refund_fee: '退款手续费',
        refund_fee_lm: '跨域退款手续费',
     
        send_refund: '出票退款',
        cross_nosend_refund: '跨月未出票退款',
        cross_send_refund: '跨月出票退款',
        cross_full_send_refund: '跨月出票全额退款',
        received_amount: '回款金额',
        profit: '利润'
      },
      selectedYear : '总数据',
      metricValues: {
        total_orders: { value: 1000, rate: 20 },
        completed_orders: { value: 900, rate: -5 },
        refunded_orders: { value: 100, rate: 15 },
        lm_refunded_orders: { value: 30, rate: -8 },
        all_in: { value: 500000, rate: 25 },
        all_out: { value: 400000, rate: 10 },
        order_amount: { value: 550000, rate: 30 },
        refund_amount: { value: 50000, rate: -12 },
        cross_month_refund: { value: 20000, rate: -15 },
        ticket_cost: { value: 380000, rate: 8 },
        refund_fee: { value: 3000, rate: -20 },
        refund_fee_lm: { value: 1000, rate: -25 },
        direct_refund: { value: 30000, rate: 5 },
        received_amount: { value: 480000, rate: 18 },
        profit: { value: 80000, rate: 35 }
      },
      stats:{
        id : 0
      },
      tableData: [],
      month_list : [],
      yearChartOption: {
        title: {
          text: '年度趋势'
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            const data = params[0];
            let value = data.value;
            if (this.isMoneyMetric(this.yearSelectedMetric)) {
              value = '¥' + this.formatNumber(value);
            }
            return `${data.name}<br/>${data.seriesName}: ${value}`;
          }
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value) => {
              if (this.isMoneyMetric(this.yearSelectedMetric)) {
                return '¥' + this.formatNumber(value);
              }
              return value;
            }
          }
        },
        series: [{
          type: 'line',
          data: [],
          name: ''
        }]
      },
      chartOption: {
        title: {
          text: '数据走势'
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            const data = params[0];
            let value = data.value;
            if (this.isMoneyMetric(this.selectedMetric)) {
              value = '¥' + this.formatNumber(value);
            }
            return `${data.name}<br/>${data.seriesName}: ${value}`;
          }
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value) => {
              if (this.isMoneyMetric(this.selectedMetric)) {
                return '¥' + this.formatNumber(value);
              }
              return value;
            }
          }
        },
        series: [
          {
            type: 'line',
            data: [],
            name: ''
          }
        ]
      }
    }
  },
  computed: {
    datePickerType() {
      return 'month'
    },
    dateFormat() {
         return 'yyyy年MM月'
      
    },
   
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchData()
    })
  
    this.updateChartData()
    this.year_data()
    this.f5()
  },
  methods: {
    year_data(){
      axios.get(base_url + '/stats101/all_data').then(res => {
        this.yearData = res.data.data;
        if (this.yearData.length > 0) {
          this.stats = this.yearData[0].data;
          this.stats.id = 1;
        }
        this.handleYearChange()
        this.is_load ++
      });
    },
    handleYearChange() {
      const selectedData = this.yearData.find(item => item.title === this.selectedYear);
      if (selectedData) {
        this.stats = selectedData.data;
        this.stats.id = 1;
        this.month_list = selectedData.month_list
      }
    },
    // 处理年度指标变化
    handleYearMetricChange() {
      if (this.month_list) {
        this.yearChartOption = {
          ...this.yearChartOption,
          xAxis: {
            ...this.yearChartOption.xAxis,
            data: this.month_list.map(item => item.month)
          },
          series: [{
            type: 'line',
            data: this.month_list.map(item => item[this.yearSelectedMetric]),
            name: this.metricOptions[this.yearSelectedMetric]
          }],
          title: {
            text: `${this.metricOptions[this.yearSelectedMetric]}年度趋势图`
          }
        };
      }
    },
    f5(){
      axios.get(base_url + '/stats101/month?month='+this.selectedDate).then(res => {
        let data =   res.data.data 
        console.log(data)
      
        this.metricValues = data.card
        this.tableData = data.day_data
        this.handleMetricChange()
        this.is_load ++
        
      })
    },
    formatNumber(value) {
      if (!value) {
        return 0;
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    handleDimensionChange() {
      this.fetchData()
    },
    handleDateChange() {
     
      this.f5()
    },
    handleMetricChange() {
      this.updateChartData()
    },
    isMoneyMetric(metric) {
      return [
        'all_in',
        'all_out',
        'order_amount',
        'refund_amount',
        'cross_month_refund',
        'ticket_cost',
        'refund_fee',
        'refund_fee_lm',
        'direct_refund',
        'received_amount',
        'profit'
      ].includes(metric)
    },
    async fetchData() {
      try {
        // 模拟API调用
        
        this.$nextTick(() => {
          this.updateChartData()
        })
      } catch (error) {
        console.error('获取数据失败：', error)
      }
    },
    async updateChartData() {
      const dates = this.tableData.map(item => item.date)
      this.chartOption = {
        ...this.chartOption,
        xAxis: {
          ...this.chartOption.xAxis,
          data: dates
        },
        series: [{
          type: 'line',
          data: this.tableData.map(item => item[this.selectedMetric]),
          name: this.metricOptions[this.selectedMetric]
        }],
        title: {
          text: `${this.metricOptions[this.selectedMetric]}走势图`
        }
      }
      await this.$nextTick()
    }
  }
}
</script>

<style scoped>
.drawer-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #f0f2f5;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 16px;
  transition: all 0.3s;
}

.drawer-trigger:hover {
  background: #e6e8eb;
}

.drawer-trigger span {
  font-size: 14px;
  color: #606266;
}

.drawer-content {
  padding: 20px;
}

.year-tabs-container {
  margin: 20px 0;
  background: linear-gradient(135deg, #ffffff, #f8fafc);
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  padding: 15px;
}

.year-tabs {
  --el-tabs-header-height: 50px;
}

.year-tabs >>> .el-tabs__header {
  margin: 0;
}

.year-tabs >>> .el-tabs__nav-wrap::after {
  background-color: transparent;
}

.year-tabs >>> .el-tabs__item {
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  color: #606266;
  transition: all 0.3s ease;
}

.year-tabs >>> .el-tabs__item.is-active {
  color: #409EFF;
  font-weight: 600;
}

.year-tabs >>> .el-tabs__active-bar {
  height: 3px;
  background-color: #409EFF;
}

.header-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 12px 0 24px;
  padding: 8px 16px;
  background: #f8fafc;
  border-radius: 8px;
  height: 56px;
}

.header-container .month-title {
  font-size: 16px;
  color: #2d3748;
  margin: 0;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-right: 50px;
}
  

.stats-display {
  padding: 20px;
}

.charts-section {
  margin-top: 20px;
}

.chart-container {
  width: 100%;
  height: 400px;
  margin-top: 20px;
}

.chart {
  width: 100%;
  height: 100%;
}

 
.stats-cards {
  margin-bottom: 30px;
}

.stats-card {
  height: 100%;
  transition: all 0.3s ease;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border: none;
  padding: 20px;
}

.stats-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

/* 收入统计卡片 */
.stats-cards .el-col:nth-child(1) .stats-card {
  background: linear-gradient(135deg, #ffffff, #ecf5ff);
}

.stats-cards .el-col:nth-child(1) .card-title {
  color: #409EFF;
}

.stats-cards .el-col:nth-child(1) .stat-item .value {
  color: #409EFF;
  background-color: rgba(64, 158, 255, 0.1);
  padding: 4px 8px;
  border-radius: 4px;
}

/* 支出统计卡片 */
.stats-cards .el-col:nth-child(2) .stats-card {
  background: linear-gradient(135deg, #ffffff, #f5f3ff);
}

.stats-cards .el-col:nth-child(2) .card-title {
  color: #6B5ECD;
}

.stats-cards .el-col:nth-child(2) .stat-item .value {
  color: #6B5ECD;
  background-color: rgba(107, 94, 205, 0.1);
  padding: 4px 8px;
  border-radius: 4px;
}

/* 退款统计卡片 */
.stats-cards .el-col:nth-child(3) .stats-card {
  background: linear-gradient(135deg, #ffffff, #fdf6ec);
}

.stats-cards .el-col:nth-child(3) .card-title {
  color: #E6A23C;
}

.stats-cards .el-col:nth-child(3) .stat-item .value {
  color: #E6A23C;
  background-color: rgba(230, 162, 60, 0.1);
  padding: 4px 8px;
  border-radius: 4px;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.06);
}

.stat-item {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  transition: all 0.3s ease;
  border-radius: 8px;
}

.stat-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.stat-item .label {
  color: #606266;
  font-size: 14px;
}

.stat-item .value {
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
}

.profit-positive {
  color: #67C23A !important;
  font-weight: 700;
  padding: 4px 8px;
  background-color: rgba(103, 194, 58, 0.1) !important;
  border-radius: 4px;
}

.profit-negative {
  color: #F56C6C !important;
  font-weight: 700;
  padding: 4px 8px;
  background-color: rgba(245, 108, 108, 0.1) !important;
  border-radius: 4px;
}

.charts-section {
  margin: 30px 0;
}

.chart-controls {
  margin-bottom: 20px;
}

.chart-container {
  height: 400px;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.chart-container .chart {
  height: 100%;
  width: 100%;
}

.data-table {
  margin-top: 30px;
}

.metric-group {
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
  padding: 12px;
  border-radius: 8px;
}

.metric-group.income {
  background: rgba(64, 158, 255, 0.1);
  border: 1px solid rgba(64, 158, 255, 0.2);
}

.metric-group.expense {
  background: rgba(245, 108, 108, 0.1);
  border: 1px solid rgba(245, 108, 108, 0.2);
}

.metric-group.orders {
  background: rgba(103, 194, 58, 0.1);
  border: 1px solid rgba(103, 194, 58, 0.2);
}

.metric-group.refund {
  background: rgba(230, 162, 60, 0.1);
  border: 1px solid rgba(230, 162, 60, 0.2);
}

.metric-card.income.is-active {
  background: linear-gradient(135deg, #409EFF, #66b1ff);
  color: #fff;
}

.metric-card.expense.is-active {
  background: linear-gradient(135deg, #F56C6C, #f78989);
  color: #fff;
}

.metric-card.orders.is-active {
  background: linear-gradient(135deg, #67C23A, #85ce61);
  color: #fff;
}

.metric-card.refund.is-active {
  background: linear-gradient(135deg, #E6A23C, #ebb563);
  color: #fff;
}

.group-title {
  font-size: 14px;
  color: #374151;
  margin: 0;
  font-weight: 600;
  writing-mode: vertical-lr;
  padding: 12px 0;
  text-orientation: mixed;
  white-space: nowrap;
}

.stats-section {
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
  margin-bottom: 16px;
}

.metric-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  flex: 1;
  margin-left: 12px;
}

.metric-card {
  background: #fff;
  border-radius: 6px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e5e7eb;
  border-left: 3px solid transparent;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.metric-card.income {
  border-left-color: #409EFF;
}

.metric-card.expense {
  border-left-color: #F56C6C;
}

.metric-card.orders {
  border-left-color: #67C23A;
}

.metric-card.refund {
  border-left-color: #E6A23C;
}

.metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.metric-card.income.is-active {
  background: linear-gradient(135deg, #409EFF, #66b1ff);
  color: #fff;
}

.metric-card.expense.is-active {
  background: linear-gradient(135deg, #F56C6C, #f78989);
  color: #fff;
}

.metric-card.orders.is-active {
  background: linear-gradient(135deg, #67C23A, #85ce61);
  color: #fff;
}

.metric-card.refund.is-active {
  background: linear-gradient(135deg, #E6A23C, #ebb563);
  color: #fff;
}

.metric-card.is-active .metric-label,
.metric-card.is-active .metric-value .value,
.metric-card.is-active .metric-value .rate,
.metric-card.is-active .metric-value .rate.up,
.metric-card.is-active .metric-value .rate.down {
  color: #fff;
}

.metric-card.income {
  border-left-color: #409EFF;
}

.metric-card.expense {
  border-left-color: #F56C6C;
}

.metric-card.orders {
  border-left-color: #67C23A;
}

.metric-card.refund {
  border-left-color: #E6A23C;
}

.metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1);
}

.metric-label {
  font-size: 13px;
  color: #4b5563;
  margin-bottom: 6px;
}

.metric-value {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.metric-value .value {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.metric-value .rate {
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 2px;
}

.rate.up {
  color: #10b981;
}

.rate.down {
  color: #ef4444;
}

.iconfont {
  font-size: 12px;
}

.icon-up:before {
  content: "↑";
}

.icon-down:before {
  content: "↓";
}
</style>